/** רושם את ה-service worker (sw.js) אם הדפדפן תומך. בלי זה חלק
 *  מהדפדפנים (Chrome/Edge) לא מציעים כלל התקנה של האפליקציה.
 *  כישלון רישום רק אומר שההתקנה לא תוצע — לא פוגע בשום דבר אחר. */
export function registerServiceWorker(nav = typeof navigator !== "undefined" ? navigator : undefined) {
  if (!nav || !("serviceWorker" in nav)) return;
  nav.serviceWorker.register("/sw.js").catch(() => {});
}
